module.exports = __webpack_public_path__ + "static/media/paul.b9ad68d6.jpeg";